import * as React from "react";
import { CountdownTimer } from "@grandvisionhq/common";
import { compose } from "@grandvisionhq/utils";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
const CmsCountdownTimerDocument = ({ component }) => {
  const { endDate, showCountdown, countdownText, url, layout } = component.getParameters();
  return /* @__PURE__ */ React.createElement(
    CountdownTimer,
    {
      endDate,
      countdownText,
      showCountdown,
      url,
      layout
    }
  );
};
const CmsCountdownTimerDocument$1 = compose(
  withBreakpointVisibility,
  withAnchor
)(CmsCountdownTimerDocument);
export {
  CmsCountdownTimerDocument,
  CmsCountdownTimerDocument$1 as default
};
//# sourceMappingURL=CountdownTimerDocument.js.map
